import type { GeneralConfig } from '@shared/types/Config';

export const approvalAuthorityConfig: GeneralConfig = {
    sortFieldMap: {},
};
